import { Component, Input } from '@angular/core';

/** 可傳入本元件的批號來源（寬鬆型別，各批號 DTO 結構相容即可傳入） */
export interface BatchStopSource {
  IsStopBatch?: boolean;
  IsUnassigned?: boolean;
}

/** 停用批標記（目前/每日/每月庫存清單 + 批號下拉共用）—— 文案與外觀集中一份，勿在各頁重寫 */
@Component({
  selector: 'app-stocks-batch-stop-icon',
  template: `<mat-icon *ngIf="batch?.IsStopBatch && !batch?.IsUnassigned"
    class="batch-stop-icon" [title]="tooltip">block</mat-icon>`,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      flex: 0 0 auto;
    }
    .batch-stop-icon {
      font-size: 16px;
      line-height: 16px;
      width: 16px;
      height: 16px;
      margin: 0;
      color: #c62828;
    }
  `]
})
export class BatchStopIconComponent {
  /** 批號來源物件（讀 IsStopBatch/IsUnassigned；未指定批不標記，它設計上恆可用） */
  @Input() batch: BatchStopSource = null;

  readonly tooltip = '批號已停用：僅供調整/盤點沖銷殘量';
}
